export const cladifyItemPriceTemplate = [
    { 
      id: 'title',
      form: {
        component: 'VTextField',
        bind: {
          placeholder: 'Detailed pricing section title'
        }
      },
      display: {
        component: 'h2'
      },
      value: null
    },
    { 
      id: 'content',
      display: {
        component: 'DetailedPricingCladifyItem',
        bind: {
          itemId: null
        }
      },
      value: ''
    },
    { 
      id: 'desc',
      form: {
        component: 'VTextField',
        bind: {
          placeholder: 'Detailed pricing section description'
        }
      },
      display: {
        component: 'p'
      },
      value: ''
    }
  ]